import {ControllerFlowAPI} from '@wix/yoshi-flow-editor'

import {reservationsService} from '../../../services/reservationsService'
import {RequestStatus} from '../../../utils/wrapRequest'

export const getReservation = (flowAPI: ControllerFlowAPI) => {
  return async (reservationId: string) => {
    const setProps = flowAPI.controllerConfig.setProps
    const {getResolvedError} = flowAPI.errorHandler
    try {
      setProps({getReservationStatus: RequestStatus.LOADING})
      const reservation = await reservationsService.getReservation(flowAPI, reservationId)

      setProps({getReservationStatus: RequestStatus.RESOLVED, reservation})
      return reservation
    } catch (err) {
      const resolvedError = getResolvedError(err)

      setProps({
        getReservationStatus: RequestStatus.FAILED,
        apiRequestErrorDetails: resolvedError,
      })
    }
  }
}
